import { ClipboardCheck, ShieldCheck, FileText, LineChart, Coins, TrendingUp } from "lucide-react";
import { useLang } from "../contexts/LanguageContext";

const ICONS = [ClipboardCheck, ShieldCheck, FileText, LineChart, Coins, TrendingUp];

export default function Services() {
  const { t } = useLang();
  return (
    <section id="services" className="section-pad">
      <div className="container-cb">
        <div className="grid lg:grid-cols-12 gap-10 items-end">
          <div className="lg:col-span-7">
            <div className="overline mb-4 flex items-center gap-3"><span className="gold-divider" /> {t.services.overline}</div>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-semibold text-cb-primary">{t.services.title}</h2>
          </div>
          <div className="lg:col-span-5">
            <p className="text-cb-secondary text-base lg:text-lg">{t.services.sub}</p>
          </div>
        </div>

        <div className="mt-12 grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {t.services.items.map((s, i) => {
            const Icon = ICONS[i] || ClipboardCheck;
            return (
              <div key={i} className="card-cb p-7" data-testid={`service-card-${i}`}>
                <div className="w-12 h-12 rounded-xl bg-cb-dark text-white grid place-items-center">
                  <Icon size={22} />
                </div>
                <h3 className="mt-5 text-xl font-semibold text-cb-primary" style={{ fontFamily: "Outfit" }}>{s.t}</h3>
                <p className="mt-2 text-sm text-cb-secondary leading-relaxed">{s.d}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
